import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../../shared/formly/ga-formly.service';
import { TranslationService } from '../../../../shared/translation/translation.service';
import { IDialogButton } from '../../../../shared/message/ga-message.service';
import { BUTTON_SAVE } from '../../../../shared/message/dialogs/default-form-dialog.component';
import { GaValidateService } from '../../../../shared/formly/ga-validate.service';
import * as _ from 'underscore';
import { BPProfilesBankDataService } from './bp-profiles-bank-data.service';

interface IPaypalConnect {
  clientId?:string;
  secret?:string;
}

@Component({
  selector: 'paypal-connect',
  template: `
    <default-dialog [title]="('BPPROFILES.BANK.PAYPAL_CONNECT' | translate)" [buttons]="buttons" dialogClass="paypal-connect" [closeButton]="true" (onClose)="onCancel.emit()">
      <formly [form]="form" [fields]="fields" [model]="model"></formly>
      <faq-item faqCode="PAYPAL_STRIPE_CONNECT"></faq-item>
    </default-dialog>
  `,
  styleUrls: ['./paypal-connect-dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PaypalConnectDialogComponent implements OnInit {
  public form:UntypedFormGroup = new UntypedFormGroup({});
  public fields:IExtraFieldConfigurationObject[] = [];
  public model:IPaypalConnect = {};
  public buttons:IDialogButton[];

  @Input() public profileId:number;

  @Output() public onCancel:EventEmitter<void> = new EventEmitter<void>();
  @Output() public onSaved:EventEmitter<void> =  new EventEmitter<void>();

  constructor(
    private formlyService:GaFormlyService,
    private translationService:TranslationService,
    private validateService:GaValidateService,
    private bpProfilesBankDataService:BPProfilesBankDataService
  ) {
    /**/
  }

  public ngOnInit():void {
    // create fields
    this.fields = this.createFields();

    // create dialog buttons
    this.buttons = this.createDialogButtons();
  }

  private createFields():IExtraFieldConfigurationObject[] {
    const labelClass:string = 'col-md-2';
    const valueClass:string = 'col-md-10';
    const infoText:string = this.translationService.instant('BPPROFILES.BANK.PAYPAL_CONNECT_INFO');

    return [
      this.formlyService.anInput('clientId', 'Client ID')
        .isRequired()
        .withInfo(infoText)
        .showInfo()
        .withLabelClass(labelClass)
        .withValueClass(valueClass)
        .build(),

      this.formlyService.anInput('secret', 'Secret')
        .isRequired()
        .withInfo(infoText)
        .withLabelClass(labelClass)
        .withValueClass(valueClass)
        .withPlaceholder()
        .build()
    ];
  }

  private createDialogButtons():IDialogButton[] {
    return [
      {
        id: BUTTON_SAVE,
        label: 'BPPROFILES.BUTTONS.CONNECT',
        className: 'btn btn-success',
        onClick: this.onSave
      },
      {
        label: 'GA.BUTTONS.CANCEL',
        className: 'btn btn-danger',
        onClick: () => this.onCancel.emit()
      }
    ];
  }

  private onSave = ():void => {
    this.validateService.validateFields(this.fields, this.model, true)
      .then(() => {
        this.updateButtonsBusy(true);
        this.bpProfilesBankDataService.savePaypalDetails(this.profileId, this.model.clientId, this.model.secret)
          .then(() => {
            this.onSaved.emit();
          })
          .finally(() => {
            this.updateButtonsBusy(false);
          });
      });
  };

  private updateButtonsBusy(isBusy:boolean):void {
    _.forEach(this.buttons, (button:IDialogButton, index:number) => {
      if (index > 0) {
        button.disabled = isBusy;
      } else {
        button.busy = isBusy;
      }
    });
  }
}